import React, {useState, useEffect} from 'react'
import { faUserCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useHistory } from 'react-router-dom'
import Navbar from '../components/Navbar'
import '../assets/css/auth.css'
import { loginUser } from '../utils/auth'

const Signin = () => {
    const history = useHistory()
    if (sessionStorage.getItem('idToken')) {
        history.push('/dashboard')
    }
    const [isPending, setIsPending] = useState(false)

    useEffect(() => {
        document.title = 'Pouch | Signin'
    }, [])

    const login = async e => {
        e.preventDefault()
        let email = e.target.email.value
        let password = e.target.password.value
        setIsPending(true)
        try {
            let response = await loginUser(email, password)
            if (response.code === 400) {
                alert(response.message ==='Request failed with status code 400'? 'Invalid email or password' : response.message === 'Network Error'? 'something went wrong' : response.message)
            } else if (response.error) {
                alert(response.error.message ==='EMAIL_NOT_FOUND' || response.error.message==='INVALID_PASSWORD'? 'Invalid email or password': response.error.message)
            } else {
                sessionStorage.setItem('idToken', response.idToken)
                sessionStorage.setItem('localId', response.localId)
                alert('Signed in successfully!')
                history.push('/dashboard')
            }
        } catch (error) {
            alert(error.message ==='EMAIL_NOT_FOUND' || error.message==='INVALID_PASSWORD'? 'Invalid email or password': error.message)
        }
        setIsPending(false)
    }
    return (
        <>
            <Navbar />
            <div className="body bg-dark h-100 m-0">
                <div className="d-flex align-items-center justify-content-center pt-4"> 
                    <form onSubmit={login} className="p-3 mx-3 m-md-0 mt-4 shadow-lg bg-dark text-white text-center" style={{borderRadius: '15px', maxWidth: '500px', minWidth: '40%'}}>
                        <Link to="#" className="text-purple"><FontAwesomeIcon icon={faUserCircle} className="h1 display-2 text-purple" style={{background : 'white', borderRadius : '50%', padding : '3px', marginTop : '-40%'}} /></Link>
                        <h1 className="h1 font-weight-bold">Sign In</h1>
                        <h1 className="h4 mb-3 font-weight-normal text-muted"><i>Welcome back!</i></h1>
                    
                        <div className="form-group text-left">        
                            <label htmlFor="inputEmail">Email</label>
                            <input type="text" id="inputEmail" name="email" className="input form-control" placeholder="Email" required autoFocus />
                        </div>
                        <div className="form-group text-left">        
                            <label htmlFor="inputPassword">Password</label>
                            <input type="password" id="inputPassword" name="password" className="input form-control" placeholder="Password" required />
                        </div>
                        <button className="button btn btn-purple btn-block" type="submit">{!isPending ? 'Sign In': <FontAwesomeIcon icon={faSpinner} spin />}</button>
                        <p className="mb-3 mt-3 text-light"> Not registered? <Link to="/signup" className="text-purple">Create an account</Link></p>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Signin
